import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import Moment from "react-moment";
import useElementOnScreen from "../../Utility/useElementOnScreen";
import { SlPencil } from "react-icons/sl";
import {
  FaRegTrashAlt,
  FaPaperPlane,
  FaRegPaperPlane,
  FaEdit
} from "react-icons/fa";
import API from "../../Utility";
import { useParams } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';

export default function TeamMember({
  index,
  user,
  columns,
  itemsRendered,
  setItemsRendered,
  onEditSelected,
  setModalMode,
  onDeleteTeamMember
}) {
  const { project } = useParams();
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 1.0
  });

  useEffect(() => {
    if (isVisible) {
      if (!itemsRendered.find((item) => item === user._id)) {
        let newItemsRendered = [...itemsRendered];
        newItemsRendered.push(user._id);
        setItemsRendered(newItemsRendered);
      }
    }
  }, [isVisible]);

  const onResendInvite = (user) => {
    const apiCallConfig = {
      url: `/admin/${project}/team/reinvite`,
      data: user,
    };
    const apiCallAsync = async () => {
      try {
        setSubmitting(true);
        const apiCallRes = await API.post(apiCallConfig);
        setTimeout(() => {
          setSubmitting(false);
          if (apiCallRes?.message !== 'success') {
            setSubmitSuccess(null);
            throw new Error(apiCallRes);
          } else {
            setSubmitSuccess(apiCallRes);
            setSubmitError(null);
            // console.log('success: ', apiCallRes);
          }
        }, 1000);
      } catch (err) {
        setSubmitting(false);
        // console.log('error: ', err);
        if (!err.response) {
          setSubmitError(err && err.message);
        } else {
          setSubmitError(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        }
      }
    };
    apiCallAsync();
  };

  return (
    <Row key={`team-member-row-${index}`} className="team-view__row" ref={containerRef}>
      { columns.map((column, index) => {
        return (
          <Col key={`column-${index}`} className="team-view__cell" xs={column.colSpan} style={{ lineBreak: column.lineBreak || 'auto' }}>
            { column.formatter ? column.formatter(user[column.dataField], user) : user[column.dataField] }
          </Col>
        );
      })}
      <Col className="team-view__cell" xs="4">
        <Row style={{ textAlign: "right", float: 'right', justifyContent: 'flex-end' }}>
          {!user?.userToken && !submitting && !submitError && !submitSuccess ? (
            <Button
              onClick={() => {
                console.log('resend invite');
                onResendInvite(user);
              }}
              variant="outline-secondary"
            >
              <FaRegPaperPlane style={{ verticalAlign: "middle", marginRight: '5px' }} />
              <span className='hidden-xs' style={{ verticalAlign: "middle" }}>Resend Invite</span>
            </Button>
          ) : (!user?.userToken && submitting) ? (
            <div style={{ verticalAlign: "middle", marginRight: '5px', padding: '4px 8px' }}>
              <div className='team-view__member__loader'>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            </div>
          ) : (!user?.userToken && submitSuccess) ? (
            <div style={{ verticalAlign: "middle", marginRight: '5px', padding: '8px' }}>Invite Sent</div>
          ) : (!user?.userToken && submitError) ? (
            <div style={{ verticalAlign: "middle", marginRight: '5px', padding: '8px' }}>Something went wrong</div>
          ) : (
            <></>
          )}
          <Button
            onClick={() => {
              onEditSelected();
              setModalMode('edit');
            }}
            variant="outline-secondary"
          >
            <FaEdit style={{ verticalAlign: "middle", marginRight: '5px' }} />
            <span className='hidden-xs' style={{ verticalAlign: "middle" }}>Edit</span>
          </Button>
          <Button
            onClick={() => {
              onDeleteTeamMember(user);
            }}
            variant="outline-secondary"
          >
            <FaRegTrashAlt style={{ verticalAlign: "middle", marginRight: '5px' }} />
            <span className='hidden-xs' style={{ verticalAlign: "middle" }}>Delete</span>
          </Button>
        </Row>
      </Col>
    </Row>
  );
}